/**
 * Window Measuring Form — 产品页弹窗与「测量指南」Section 共用
 * 根节点需带 data-measure-guide-form 及 data-mg-* 范围属性
 */
(function () {
  function initMeasureGuideForm(form) {
    if (!form || form.getAttribute('data-measure-guide-form') !== 'true') return;
    if (form.getAttribute('data-measure-guide-init') === 'true') return;
    form.setAttribute('data-measure-guide-init', 'true');

    var VARIANCE_MAX_CM = 1.6;
    var VARIANCE_MAX_IN = 0.63;
    var RECESS_MIN_CM = 3;
    var RECESS_MIN_IN = 1.18;
    var CM_PER_IN = 2.54;

    var unitOpts = form.querySelectorAll('.mg-unit-opt');
    var inputs = {
      widthTop: form.querySelector('.mg-width-top'),
      widthMiddle: form.querySelector('.mg-width-middle'),
      widthBottom: form.querySelector('.mg-width-bottom'),
      heightLeft: form.querySelector('.mg-height-left'),
      heightCenter: form.querySelector('.mg-height-center'),
      heightRight: form.querySelector('.mg-height-right'),
      recess: form.querySelector('.mg-recess')
    };
    var errWidthEl = form.querySelector('.mg-width-validation');
    var errHeightEl = form.querySelector('.mg-height-validation');
    var errRecessEl = form.querySelector('.mg-recess-validation');
    var out = {
      orderWidth: form.querySelector('.mg-summary-order-width'),
      orderHeight: form.querySelector('.mg-summary-order-height'),
      recess: form.querySelector('.mg-summary-recess'),
      diagramWidth: form.querySelector('.mg-svg-width-val'),
      diagramHeight: form.querySelector('.mg-svg-height-val'),
      cardWidth: form.querySelector('.mg-order-width-display'),
      cardHeight: form.querySelector('.mg-order-height-display'),
      cardRecess: form.querySelector('.mg-order-recess-display')
    };
    var cardWBox = form.querySelector('.mg-card-width');
    var cardHBox = form.querySelector('.mg-card-height');
    var cardRBox = form.querySelector('.mg-card-recess-wrap');

    function getUnit() {
      return form.querySelector('.mg-unit-opt.is-selected');
    }
    function getUnitLabel() {
      var u = getUnit();
      return u && u.getAttribute('data-unit') === 'inch' ? 'in' : 'cm';
    }
    function parseNum(val) {
      var n = parseFloat(val);
      return isNaN(n) ? null : n;
    }
    function readAttr(name) {
      var v = parseFloat(form.getAttribute(name));
      return isNaN(v) ? null : v;
    }
    function trioSpread(a, b, c) {
      var arr = [a, b, c].filter(function (x) {
        return x != null;
      });
      if (arr.length < 2) return null;
      return Math.max.apply(null, arr) - Math.min.apply(null, arr);
    }
    function fillErrors(container, messages) {
      if (!container) return;
      container.innerHTML = '';
      if (!messages || !messages.length) {
        container.setAttribute('hidden', '');
        return;
      }
      container.removeAttribute('hidden');
      messages.forEach(function (text) {
        var row = document.createElement('div');
        row.className = 'mg-error-line';
        var dot = document.createElement('span');
        dot.className = 'mg-error-dot';
        var span = document.createElement('span');
        span.textContent = text;
        row.appendChild(dot);
        row.appendChild(span);
        container.appendChild(row);
      });
    }
    function setCardError(cardEl, on) {
      if (!cardEl) return;
      if (on) cardEl.classList.add('mg-card--error');
      else cardEl.classList.remove('mg-card--error');
    }
    function formatMgDecimal(v) {
      if (v == null || isNaN(v)) return '';
      var r = Math.round(v * 10) / 10;
      return r % 1 === 0 ? String(r) : r.toFixed(1);
    }
    function convertMgInputsOnUnitChange(fromInch, toInch) {
      if (fromInch === toInch) return;
      var list = [
        inputs.widthTop,
        inputs.widthMiddle,
        inputs.widthBottom,
        inputs.heightLeft,
        inputs.heightCenter,
        inputs.heightRight,
        inputs.recess
      ];
      list.forEach(function (el) {
        if (!el) return;
        var raw = String(el.value || '').trim();
        if (raw === '') return;
        var n = parseFloat(raw);
        if (isNaN(n)) return;
        if (fromInch && !toInch) n = n * CM_PER_IN;
        else if (!fromInch && toInch) n = n / CM_PER_IN;
        el.value = formatMgDecimal(n);
      });
    }
    function setSummaryLine(lineClass, textEl, prefix, valueStr, msgs, isCompleteOk) {
      var line = form.querySelector('.mg-summary-line' + lineClass);
      if (!textEl) return;
      if (line) {
        line.classList.remove('mg-summary-line--error', 'mg-summary-line--ok', 'mg-summary-line--empty');
        if (msgs && msgs.length) line.classList.add('mg-summary-line--error');
        else if (isCompleteOk) line.classList.add('mg-summary-line--ok');
        else line.classList.add('mg-summary-line--empty');
      }
      var base = prefix + valueStr;
      if (msgs && msgs.length) textEl.textContent = base + ' — ' + msgs.join(' · ');
      else textEl.textContent = base;
    }
    function update() {
      var unit = getUnitLabel();
      var isInch = unit === 'in';
      var w1 = parseNum(inputs.widthTop && inputs.widthTop.value);
      var w2 = parseNum(inputs.widthMiddle && inputs.widthMiddle.value);
      var w3 = parseNum(inputs.widthBottom && inputs.widthBottom.value);
      var h1 = parseNum(inputs.heightLeft && inputs.heightLeft.value);
      var h2 = parseNum(inputs.heightCenter && inputs.heightCenter.value);
      var h3 = parseNum(inputs.heightRight && inputs.heightRight.value);
      var recessVal = parseNum(inputs.recess && inputs.recess.value);
      var minW = [w1, w2, w3].filter(function (x) {
        return x != null;
      });
      var minH = [h1, h2, h3].filter(function (x) {
        return x != null;
      });
      var orderW = minW.length ? Math.min.apply(null, minW) : null;
      var orderH = minH.length ? Math.min.apply(null, minH) : null;
      var widthAllFilled = minW.length === 3;
      var heightAllFilled = minH.length === 3;
      var dash = '—';
      var fmt = function (v) {
        return v != null
          ? (Number(v) === v && v % 1 !== 0 ? v.toFixed(1) : v) + ' ' + unit
          : dash;
      };
      var widthValStr = widthAllFilled && orderW != null ? fmt(orderW) : dash;
      var heightValStr = heightAllFilled && orderH != null ? fmt(orderH) : dash;
      var recessValStr = recessVal != null ? fmt(recessVal) : dash;
      if (out.diagramWidth) out.diagramWidth.textContent = orderW != null ? fmt(orderW) : dash;
      if (out.diagramHeight) out.diagramHeight.textContent = orderH != null ? fmt(orderH) : dash;
      if (out.cardWidth) out.cardWidth.textContent = orderW != null ? fmt(orderW) : dash;
      if (out.cardHeight) out.cardHeight.textContent = orderH != null ? fmt(orderH) : dash;
      if (out.cardRecess) out.cardRecess.textContent = recessVal != null ? fmt(recessVal) : dash;

      var minWlim = isInch ? readAttr('data-mg-min-w-in') : readAttr('data-mg-min-w-cm');
      var maxWlim = isInch ? readAttr('data-mg-max-w-in') : readAttr('data-mg-max-w-cm');
      var minHlim = isInch ? readAttr('data-mg-min-h-in') : readAttr('data-mg-min-h-cm');
      var maxHlim = isInch ? readAttr('data-mg-max-h-in') : readAttr('data-mg-max-h-cm');

      var widthMsgs = [];
      var heightMsgs = [];
      var recessMsgs = [];

      if (widthAllFilled && orderW != null && minWlim != null && maxWlim != null) {
        if (orderW < minWlim || orderW > maxWlim) {
          widthMsgs.push('Width out of range (' + minWlim + '-' + maxWlim + ')');
        }
      }
      if (heightAllFilled && orderH != null && minHlim != null && maxHlim != null) {
        if (orderH < minHlim || orderH > maxHlim) {
          heightMsgs.push('Height out of range (' + minHlim + '-' + maxHlim + ')');
        }
      }

      var wSpread = trioSpread(w1, w2, w3);
      if (wSpread != null) {
        if (isInch) {
          if (wSpread > VARIANCE_MAX_IN + 1e-9) {
            widthMsgs.push('Width Variance too high (> 0.63in)');
          }
        } else if (wSpread > VARIANCE_MAX_CM + 1e-9) {
          widthMsgs.push('Width Variance too high (> 1.6cm)');
        }
      }

      var hSpread = trioSpread(h1, h2, h3);
      if (hSpread != null) {
        if (isInch) {
          if (hSpread > VARIANCE_MAX_IN + 1e-9) {
            heightMsgs.push('Height Variance too high (> 0.63in)');
          }
        } else if (hSpread > VARIANCE_MAX_CM + 1e-9) {
          heightMsgs.push('Height Variance too high (> 1.6cm)');
        }
      }

      if (recessVal != null) {
        if (isInch) {
          if (recessVal < RECESS_MIN_IN - 1e-9) recessMsgs.push('Recess too shallow (< 1.18in)');
        } else if (recessVal < RECESS_MIN_CM - 1e-9) {
          recessMsgs.push('Recess too shallow (< 3cm)');
        }
      }

      fillErrors(errWidthEl, widthMsgs);
      fillErrors(errHeightEl, heightMsgs);
      fillErrors(errRecessEl, recessMsgs);

      setCardError(cardWBox, widthMsgs.length > 0);
      setCardError(cardHBox, heightMsgs.length > 0);
      setCardError(cardRBox, recessMsgs.length > 0);

      var widthOk = widthAllFilled && widthMsgs.length === 0;
      var heightOk = heightAllFilled && heightMsgs.length === 0;
      var recessOk = recessVal != null && recessMsgs.length === 0;

      setSummaryLine('--width', out.orderWidth, 'Order Width: ', widthValStr, widthMsgs, widthOk);
      setSummaryLine('--height', out.orderHeight, 'Order Height: ', heightValStr, heightMsgs, heightOk);
      setSummaryLine('--recess', out.recess, 'Recess: ', recessValStr, recessMsgs, recessOk);
    }

    unitOpts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var currentSel = form.querySelector('.mg-unit-opt.is-selected');
        var wasInch = currentSel && currentSel.getAttribute('data-unit') === 'inch';
        var toInch = btn.getAttribute('data-unit') === 'inch';
        if (currentSel !== btn && wasInch !== toInch) convertMgInputsOnUnitChange(wasInch, toInch);
        unitOpts.forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        update();
      });
    });
    Object.keys(inputs).forEach(function (k) {
      if (inputs[k]) {
        inputs[k].addEventListener('input', update);
        inputs[k].addEventListener('change', update);
      }
    });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-measure-guide-form="true"]').forEach(initMeasureGuideForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
